<div class="app-dialog datasource-conflict-dialog">
  <div class="app-dialog__heading">
    <button mat-icon-button type="button" class="datasource-conflict-dialog-close" aria-label="Close" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
    <div class="app-dialog__heading-copy">
      <span class="app-dialog__eyebrow">Data source</span>
      <div class="app-dialog__title-row">
        <div class="app-dialog__title-copy">
          <h2 mat-dialog-title class="app-dialog__title">Data Source Name Already Exists</h2>
          <p>Choose how to handle the existing data source.</p>
        </div>
      </div>
    </div>
  </div>

<mat-dialog-content class="app-dialog__content">
  <div class="content-box conflict-info">
    <div class="flex-start gap-md">
      <mat-icon svgIcon="warning" class="icon-warning"></mat-icon>
      <p class="conflict-message">
        A data source with the name <strong>"{{ data.datasourceName }}"</strong> already exists.
      </p>
    </div>
  </div>

  <div *ngIf="!showRenameInput">
    <p class="options-prompt">How would you like to proceed?</p>

    <!-- Replace Option -->
    <div class="box-light-grey option-section">
      <div class="flex-start gap-md option-header">
        <mat-icon svgIcon="refresh"></mat-icon>
        <h3>Replace Data</h3>
      </div>
      <p class="option-description">
        Replace the existing data source with the new uploaded file.
      </p>
      <div *ngIf="isLoadingProjects" class="flex-start gap-sm status-message">
        <mat-spinner diameter="16"></mat-spinner>
        <span>Checking project usage...</span>
      </div>
      <div *ngIf="!isLoadingProjects && projectCount > 0" class="info-box warning">
        <div class="flex-start gap-sm">
          <mat-icon svgIcon="warning"></mat-icon>
          <span>
            <strong>Warning:</strong> This data source is currently used by 
            <strong>{{ projectCount }}</strong> project{{ projectCount !== 1 ? 's' : '' }}.
            Replacing the data will affect {{ projectCount === 1 ? 'this project' : 'these projects' }}.
          </span>
        </div>
      </div>
      <div *ngIf="!isLoadingProjects && projectCount === 0" class="info-box">
        <div class="flex-start gap-sm">
          <mat-icon svgIcon="info"></mat-icon>
          <span>This data source is not currently used by any projects.</span>
        </div>
      </div>
      <button 
        mat-raised-button 
        color="warn"
        [disabled]="isLoadingProjects"
        (click)="onReplace()">
        Replace Data
      </button>
    </div>

    <!-- Use Existing Option -->
    <div class="box-light-grey option-section">
      <div class="flex-start gap-md option-header">
        <mat-icon svgIcon="check_circle"></mat-icon>
        <h3>Use Existing Data Source</h3>
      </div>
      <p class="option-description">
        Use the existing data source without uploading a new file.
      </p>
      <button 
        mat-raised-button 
        color="primary"
        (click)="onUseExisting()">
        Use Existing
      </button>
    </div>

    <!-- Rename Option -->
    <div class="box-light-grey option-section">
      <div class="flex-start gap-md option-header">
        <mat-icon svgIcon="pencil"></mat-icon>
        <h3>Create with New Name</h3>
      </div>
      <p class="option-description">
        Enter a new name and create a new data source with your uploaded file.
      </p>
      <button 
        mat-raised-button 
        color="accent"
        (click)="onShowRenameInput()">
        Enter New Name
      </button>
    </div>
  </div>

  <!-- Rename Input Section -->
  <div *ngIf="showRenameInput" class="box-light-grey rename-section">
    <h3>Enter a New Data Source Name</h3>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Data Source Name</mat-label>
      <input 
        matInput 
        [(ngModel)]="newDatasourceName" 
        placeholder="Enter new name"
        (keyup.enter)="onRename()">
    </mat-form-field>
    <div *ngIf="errorMessage" class="error-message flex-start gap-sm">
      <mat-icon svgIcon="error"></mat-icon>
      <span>{{ errorMessage }}</span>
    </div>
    <div class="flex-end gap-md rename-actions">
      <button mat-button (click)="onCancelRename()">
        Back
      </button>
      <button 
        mat-raised-button 
        color="primary" 
        (click)="onRename()"
        [disabled]="!newDatasourceName.trim()">
        Create with New Name
      </button>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="app-dialog__actions" *ngIf="!showRenameInput" align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
</mat-dialog-actions>
</div>
